<template>
  <section class="py-5 features-section">
    <div class="container">
      <h2 class="mb-2 text-center display-6 fw-bold text-primary animate__animated animate__fadeInDown">
        <i class="fas fa-handshake me-2"></i> Ce oferim
      </h2>
      <p class="text-center text-muted mb-5 mx-auto section-subtitle">
        Servicii complete de consultanță pentru toate etapele procesului de achiziție publică.
      </p>

      <div class="row g-3 g-md-4">
        <div class="col-6 col-lg-3">
          <div class="feature-card h-100 p-3 p-md-4 shadow-sm rounded-4 bg-white hover-up animate__animated animate__fadeInUp">
            <div class="icon-wrap mb-3">
              <i class="fas fa-chart-line fa-2x fa-md-3x text-primary"></i>
            </div>
            <h6 class="fw-bold feature-title">CONSULTANȚĂ OFERTANȚI</h6>
            <p class="text-muted small mb-0">Sprijin dedicat pentru a pregăti și depune oferte câștigătoare.</p>
          </div>
        </div>

        <div class="col-6 col-lg-3">
          <div class="feature-card h-100 p-3 p-md-4 shadow-sm rounded-4 bg-white hover-up animate__animated animate__fadeInUp animate__delay-1s">
            <div class="icon-wrap mb-3">
              <i class="fas fa-building fa-2x fa-md-3x text-primary"></i>
            </div>
            <h6 class="fw-bold feature-title text-uppercase">Control Intern Învățământ</h6>
            <p class="text-muted small mb-0">Implementare SCIM în unități preuniversitare, cu documentație completă.</p>
          </div>
        </div>

        <div class="col-6 col-lg-3">
          <div class="feature-card h-100 p-3 p-md-4 shadow-sm rounded-4 bg-white hover-up animate__animated animate__fadeInUp animate__delay-2s">
            <div class="icon-wrap mb-3">
              <i class="fas fa-gavel fa-2x fa-md-3x text-primary"></i>
            </div>
            <h6 class="fw-bold feature-title">CONTESTAȚII C.N.S.C.</h6>
            <p class="text-muted small mb-0">Redactare și susținere contestații în fața Consiliului Național.</p>
          </div>
        </div>

        <div class="col-6 col-lg-3">
          <div class="feature-card h-100 p-3 p-md-4 shadow-sm rounded-4 bg-white hover-up animate__animated animate__fadeInUp animate__delay-3s">
            <div class="icon-wrap mb-3">
              <i class="fas fa-briefcase fa-2x fa-md-3x text-primary"></i>
            </div>
            <h6 class="fw-bold feature-title">CONSULTANȚĂ AUTORITĂȚI</h6>
            <p class="text-muted small mb-0">Consultanță completă pentru inițiere, derulare și finalizare proceduri.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.features-section {
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
}

.section-subtitle {
  max-width: 550px;
  font-size: 0.97rem;
}

.icon-wrap {
  width: 52px;
  height: 52px;
  background: rgba(13, 110, 253, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-title {
  font-size: 0.78rem;
  line-height: 1.4;
  letter-spacing: 0.02em;
}

.hover-up {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(0,0,0,0.05);
}

.hover-up:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.1) !important;
}

@media (max-width: 576px) {
  .feature-title {
    font-size: 0.72rem;
  }
  .icon-wrap {
    width: 42px;
    height: 42px;
  }
  .fa-2x {
    font-size: 1.3em;
  }
}
</style>